<template>
  <b-row>
    <b-col v-for="card in cards" :key="card.title" cols="6" md="3" class="mb-1">
      <b-card class="mb-0 h-100">
        <div class="d-flex align-items-center">
          <b-avatar size="48" :variant="`light-${card.variant}`">
            <feather-icon :icon="card.icon" size="22" />
          </b-avatar>
          <div class="ml-1">
            <small class="text-muted d-block">{{ card.title }}</small>
            <h4 class="mb-0" :class="card.valueClass">{{ card.value }}</h4>
            <small class="text-muted">{{ card.subtitle }}</small>
          </div>
        </div>
      </b-card>
    </b-col>
  </b-row>
</template>

<script>
import { BRow, BCol, BCard, BAvatar } from 'bootstrap-vue'
import { computed } from '@vue/composition-api'
import { formatRub, formatPercent, profitVariant } from '@/views/finance/utils'

export default {
  components: { BRow, BCol, BCard, BAvatar },
  props: {
    kpis: { type: Object, default: null },
  },
  setup(props) {
    const cards = computed(() => {
      const k = props.kpis || {}
      const priv = k.private || {}
      return [
        {
          title: 'Средняя выручка/неделя',
          value: formatRub(k.avg_weekly_revenue),
          subtitle: `Медиана: ${formatRub(k.median_revenue)}`,
          icon: 'TrendingUpIcon',
          variant: 'success',
          valueClass: '',
        },
        {
          title: 'Средняя прибыль/неделя',
          value: formatRub(k.avg_weekly_profit),
          subtitle: `Медиана: ${formatRub(k.median_profit)}`,
          icon: 'DollarSignIcon',
          variant: profitVariant(k.avg_weekly_profit),
          valueClass: `text-${profitVariant(k.avg_weekly_profit)}`,
        },
        {
          title: 'Средняя маржа',
          value: formatPercent(k.avg_margin),
          subtitle: `ARPU: ${formatRub(k.arpu)}`,
          icon: 'PercentIcon',
          variant: 'primary',
          valueClass: '',
        },
        {
          title: 'Заполняемость',
          value: formatPercent(k.occupancy),
          subtitle: `За игру: ${formatRub(k.avg_revenue_per_game)}`,
          icon: 'UsersIcon',
          variant: 'warning',
          valueClass: '',
        },
        {
          title: 'Частные игры',
          value: `${priv.games_count != null ? priv.games_count : '—'} игр`,
          subtitle: `${formatRub(priv.revenue)} · ${formatPercent(priv.games_share)}`,
          icon: 'LockIcon',
          variant: 'info',
          valueClass: '',
        },
      ]
    })

    return { cards }
  },
}
</script>
